import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { BuildPriceEntities } from 'client/data/models/build-price';
import { getS3MediaProfileImageUrlBySize } from 'client/utils/image-helpers';
import { makeNiceName } from 'site-modules/shared/utils/nice-name';
import { buildNextLink } from 'site-modules/shared/utils/build-price/build-price';
import { SUBMODEL_IMAGE_SIZE } from 'site-modules/shared/constants/build-price';

export function CalculateButton({
  buildPriceFilter,
  pathname,
  modelYear: { modelName, makeName, makeSlug, modelSlug, year },
  isMobile = false,
  hasImage = false,
}) {
  const submodel = buildPriceFilter.styleFilter.submodel;
  const cta = buildPriceFilter.optionIds ? 'Calculate price' : 'Calculate without options';

  return (
    <Button
      tag="a"
      href={buildNextLink(buildPriceFilter, {}, pathname)}
      color="primary-b"
      size="lg"
      className={classnames('see-summary-button d-flex justify-content-between align-items-center p-0', {
        'w-100 card-btn': isMobile,
      })}
      data-tracking-id="build_price_next_button_vehicle_customization"
      data-tracking-value={cta}
    >
      {hasImage && (
        <div className="bg-white img-container px-0_5">
          <img
            className="button-img"
            src={getS3MediaProfileImageUrlBySize(
              {
                year,
                make: { slug: makeSlug },
                model: { slug: modelSlug },
                submodels: { slug: makeNiceName(submodel) },
              },
              SUBMODEL_IMAGE_SIZE.PREVIEW.WIDTH,
              SUBMODEL_IMAGE_SIZE.PREVIEW.HEIGHT
            )}
            alt={`${year} ${makeName} ${modelName} ${submodel}`}
          />
        </div>
      )}
      <div className="w-100 d-flex justify-content-center align-items-center py-1 py-md-0_5 px-md-1">
        {cta} <i className="d-inline-block ms-1 icon-arrow-right4" aria-hidden />
      </div>
    </Button>
  );
}

CalculateButton.propTypes = {
  modelYear: BuildPriceEntities.ModelYear.isRequired,
  buildPriceFilter: BuildPriceEntities.BuildPriceFilter.isRequired,
  pathname: PropTypes.string.isRequired,
  hasImage: PropTypes.bool,
  isMobile: PropTypes.bool,
};
